import React, { useMemo } from "react";
import { useVSU } from "../store";
import { pick, fmtDate, matchesSearch, sortItems } from "../helpers";
import EmptyState from "./EmptyState";

// Сводная таблица видеопотоков (5.11, RQ.22.06/RQ.22.07).
// Поиск и сортировка — локальные, применяются поверх серверных фильтров и на другие
// элементы раздела не влияют. Исходный порядок items[] не изменяется (сортировка на копии).
const COLS = [
  { key: "source_name", tk: "colSrc" },
  { key: "address", tk: "colAddr" },
  { key: "location", tk: "colLoc" },
  { key: "video", tk: "colFile" },
  { key: "plan_date", tk: "colPlan", num: true },
  { key: "fact_date", tk: "colFact", num: true },
];

const Dash = ({ v }) =>
  v ? <span>{v}</span> : <span className="vsu-dash">—</span>;

export default function SummaryTable() {
  const { t, lang, items, search, setSearch, sort, toggleSort } = useVSU();

  // Сначала поиск (внутри отфильтрованной выборки), затем сортировка.
  const searched = useMemo(
    () => items.filter((s) => matchesSearch(s, search, lang)),
    [items, search, lang]
  );
  const rows = useMemo(() => sortItems(searched, sort.col, sort.dir, lang), [
    searched,
    sort,
    lang,
  ]);

  const emptyDesc = items.length === 0 ? t("emptyD") : t("searchEmptyD");

  return (
    <>
      <div className="vsu-tbl-tools">
        <input
          type="search"
          className="vsu-search"
          placeholder={t("searchPh")}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <span className="vsu-cnt">
          {rows.length} {t("records")}
        </span>
      </div>

      <div className="vsu-tbl-scroll">
        <table className="vsu-table vsu-sum-table">
          <thead>
            <tr>
              {COLS.map((c) => (
                <th
                  key={c.key}
                  className={"s" + (c.num ? " n" : "")}
                  onClick={() => toggleSort(c.key)}
                >
                  {t(c.tk)}
                  {sort.col === c.key && (
                    <span className="vsu-ar">{sort.dir > 0 ? "▲" : "▼"}</span>
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={COLS.length}>
                  <EmptyState title={t("emptyT")} desc={emptyDesc} />
                </td>
              </tr>
            ) : (
              rows.map((s) => (
                <tr key={s.id}>
                  <td>{pick(s.source_name, lang)}</td>
                  <td>{pick(s.address, lang)}</td>
                  <td>{pick(s.location, lang)}</td>
                  <td>
                    {s.video.available ? (
                      // Файл публичный (permitAll) → обычная ссылка на скачивание/просмотр.
                      <a
                        className="vsu-file-link"
                        href={s.video.url}
                        download={s.video.file_name || "video.mp4"}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={t("download") || "Открыть/скачать файл"}
                      >
                        {s.video.file_name}
                      </a>
                    ) : (
                      <span className="vsu-file-no">— {t("fileNo")}</span>
                    )}
                  </td>
                  <td className="n dt">
                    <Dash v={fmtDate(s.plan_date)} />
                  </td>
                  <td className="n dt">
                    <Dash v={fmtDate(s.fact_date)} />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </>
  );
}
